import * as pricingDataTypes from '../constants/pricingPresetDataTypes';

const getCurrentPresetData = (preset, fabricatorSettings) => {
  return fabricatorSettings && fabricatorSettings.useFabricatorCostPrices
    ? preset.pricingProfileCostData
    : fabricatorSettings && fabricatorSettings.showSalePrices
      ? preset.pricingProfileDiscountData
      : preset.pricingProfileData
}

const QuotePricing = (_pricingProfiles) => {
  let pricingProfiles = [];

  try {
    for(let n = 0; n < _pricingProfiles.length; n++) {
      if(_pricingProfiles[n].PricingPresetData || _pricingProfiles[n].pricingPresetData) {
        var profile = _pricingProfiles[n];
        const presetData = _pricingProfiles[n].PricingPresetData || _pricingProfiles[n].pricingPresetData;
        const costData = _pricingProfiles[n].PricingPresetCostData || _pricingProfiles[n].pricingPresetCostData;
        const discountData = _pricingProfiles[n].PricingPresetDiscountData || _pricingProfiles[n].pricingPresetDiscountData;
        profile.pricingProfileData = presetData ? JSON.parse(presetData) : null;
        profile.pricingProfileCostData = costData ? JSON.parse(costData) : null;
        profile.pricingProfileDiscountData = discountData ? JSON.parse(discountData) : null;
        pricingProfiles.push(profile);
      }
    }
  } catch (error) {
    console.error("Error parsing JSON for pricing profile", profile, error);
  }

  var quotePricing = {
    pricingProfiles: pricingProfiles,
    calculatePrice: (
      pricingProfileId,
      materialQuantity,
      stoneSupplierStone = null,
      useSlabSqftPricing = false,
      singleSlabArea = 1,
      dbFeature,
      fabricatorSettings,
    ) => {
      let quantity = parseFloat(materialQuantity);
      var profile = quotePricing.pricingProfiles.find((pp) => {
        return (pp.Id || pp.id) === pricingProfileId;
      });
      if(!profile) {
        console.error("Invalid Pricing Profile: Id does not match an existing profile", materialQuantity, stoneSupplierStone);
        return stoneSupplierStone ? stoneSupplierStone.price * materialQuantity : -1;
      }
      var ppdList = getCurrentPresetData(profile, fabricatorSettings);
      if (!Array.isArray(ppdList) || !ppdList.length) {
        console.error("Invalid Pricing Profile: No pricingProfileData", profile, stoneSupplierStone, fabricatorSettings);
        return stoneSupplierStone ? stoneSupplierStone.price * materialQuantity : -1;
      }
      const customPrice = dbFeature && dbFeature.priceWasChanged && fabricatorSettings
        ? fabricatorSettings.useFabricatorCostPrices ? dbFeature.price : dbFeature.cost
        : 0;
      for (var n = ppdList.length - 1; n >= 0; n--) {
        let ppd = ppdList[n],
          ppdValue = parseFloat(customPrice || ppd.value),
          ppdStart = parseFloat(ppd.start),
          ppdEnd = parseFloat(ppd.end) || Infinity;

        if (ppd.type === pricingDataTypes.PRICING_PRESET_SLAB_SEG) {
          if (useSlabSqftPricing) {
            const perSqftTotalPrice = quantity * parseFloat(ppd.slabSqftValue);
            // QCDES-1936 f there is no inserted Price per SQFT in Dashboard - then We are calculating based on the dimension which are selected for the slab image
            if (!perSqftTotalPrice) {
              return ppdValue / singleSlabArea * quantity
            }
            return perSqftTotalPrice;
          } else {
            if (stoneSupplierStone && (stoneSupplierStone.ProfilePriceOverride || stoneSupplierStone.profilePriceOverride)) {
              ppdValue = stoneSupplierStone.price ? stoneSupplierStone.price : stoneSupplierStone.Price;
            }
            var slabs = parseInt(Math.ceil(quantity / ppdEnd));
            return slabs * ppdValue;
          }
        } else {
          if ( ppdEnd >= quantity && ppdStart < quantity) {
            var price = ppdValue;
            switch(ppd.type) {
              case pricingDataTypes.PRICING_PRESET_SQFT_SEG:
                return price * quantity;
              case pricingDataTypes.PRICING_PRESET_PLUS_SQFT_SEG: {
                let prev = ppdList[n - 1]
                  , prevEnd = parseFloat(prev.end)
                  , prevValue = parseFloat(prev.value)
                  , prevPrice = prevEnd * prevValue
                  , remainder = quantity - prevEnd;
                return prevPrice + (remainder * price);
              }
              case pricingDataTypes.PRICING_PRESET_PKG_SEG:
                return price;
              case pricingDataTypes.PRICING_PRESET_PLUS_PKG_SEG: {
                let prev = ppdList[n - 1]
                  , prevEnd = parseFloat(prev.end)
                  , prevPrice = parseFloat(prev.value)
                  , remainder = quantity - prevEnd;
                return prevPrice + (remainder * price);
              }
              case pricingDataTypes.PRICING_PRESET_MIN_SEG:
                //return price * ppdEnd; //Minimum
                if (useSlabSqftPricing) { //QCDES-6781 skip assigning min price for the slabs
                  break;
                }
                return price;
            }
          }
        }
        if(n === 0) { //usually gets caught here if the material value is 0 or NaN
          return quantity * ppdList[0].price;
        }
      }
      //this code should never be reached, but just in case, default to sqft price
      console.error('Code reached that should never be reached in QuotePricing module calculatePrice function', pricingProfiles, pricingProfileId, materialQuantity);
      return quantity * ppdList[0].price;
    },
    hasPricingProfileAssigned: (stoneSupplierStone, fabricatorSettings) => {
      if(stoneSupplierStone) {
        var ppid = stoneSupplierStone.PricingPreset_Id || stoneSupplierStone.pricingPreset_Id || stoneSupplierStone.pricingPreset_id;
        var profile = quotePricing.pricingProfiles.find((pp) => {
          return ppid && (ppid === pp.Id || ppid === pp.id);
        });
        if (!profile) {
          return false
        }
        var ppdList = getCurrentPresetData(profile, fabricatorSettings);
        return Array.isArray(ppdList) && ppdList.length > 0
      }
      return false;
    }
  };
  return quotePricing;
};

export default QuotePricing;
export { QuotePricing, getCurrentPresetData };